import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components/macro';

import Popup from 'components/Popup';
import PlayIcon from 'components/PlayIcon';
import { useSyncVideo } from 'services/sync/SyncContext';

const VideoPopup = ({ video, image, size = 'main', ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    const videoRef = useRef(null);

    useSyncVideo(videoRef, isOpen);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => {
        if (videoRef.current) {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
        }
        setIsOpen(false);
    };

    // Start video when popup opens
    useEffect(() => {
        if (isOpen && videoRef.current) {
            const playVideo = async () => {
                try {
                    await videoRef.current.play();
                } catch (error) {
                    // Autoplay was prevented, user will need to click play manually
                    console.log('Autoplay prevented:', error.message);
                }
            };

            const timer = setTimeout(playVideo, 100);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    return (
        <>
            <VideoPlaceholder {...props} onClick={handleOpen}>
                <Image src={image?.sizes?.[size]} alt="" />
                <Icon />
            </VideoPlaceholder>
            
            <Popup isOpen={isOpen} onClose={handleClose}>
                <Container>
                    <Video 
                        ref={videoRef}
                        id="video" 
                        width="100%" 
                        height="100%" 
                        controls
                        controlsList="nofullscreen"
                        preload="auto"
                    >
                        <source src={video?.url} type="video/mp4" />
                    </Video>
                </Container>
            </Popup>
        </>
    );
};


export default VideoPopup;


const VideoPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    cursor: pointer;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.app_background};
`;

const Video = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Icon = styled(PlayIcon)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16rem;
    pointer-events: none;
`;